const Component = {
  render: function render() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _vm._m(0)
  },
  staticRenderFns: [
    function() {
      var _vm = this
      var _h = _vm.$createElement
      var _c = _vm._self._c || _h
      return _c('div', [
        _c('h1', { staticClass: 'uk-h1 tm-heading-fragment' }, [
          _vm._v('Form')
        ]),
        _c('p', { staticClass: 'uk-text-lead' }, [
          _vm._v(
            'Easily create nice looking forms with different styles and layouts.'
          )
        ]),
        _vm._v(' '),
        _c(
          'h2',
          { staticClass: 'uk-h2 tm-heading-fragment', attrs: { id: 'usage' } },
          [_c('a', { attrs: { href: '#usage' } }, [_vm._v('Usage')])]
        ),
        _c('p', [
          _vm._v(
            'The form component has not yet been converted to Vuikit, but as most of it is just plain HTML you can use the '
          ),
          _c(
            'a',
            {
              attrs: {
                href: 'https://getuikit.com/docs/form',
                target: '_blank'
              }
            },
            [_vm._v('UIkit syntax')]
          ),
          _vm._v(' directly. ')
        ])
      ])
    }
  ],
  data: function() {
    return {}
  },
  scrollToTop: true,
  sections: [{ id: 'usage', title: 'Usage' }],
  components: {}
}


export default Component
